import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import moment from 'moment';

import { createToast, toastType } from 'Common/ToastHelper';
import * as setDateAndSetActions from 'PointOfSale/modules/setDateAndSite/state/action';
import * as mealTypesActions from 'PointOfSale/modules/mealTypes/state/actions';
import { getPosData } from 'PointOfSale/state/actions';
import SetDateAndSiteComponent from 'PointOfSale/modules/setDateAndSite/component';

import { getServerTime } from 'State/serverTime/actions';
import * as CommonSelectors from 'State/selectors';
import * as POSSelectors from 'PointOfSale/selectors';
import { toggleFullscreen } from 'Common/UI/state/actions';

class SetDateAndSite extends Component {
  constructor(props) {
    super(props);
    const state = {
      siteDate: props.serverTime,
      selectedSite: null,
    };
    if (props.siteDate) {
      state.siteDate = props.siteDate;
    }
    if (props.selectedSiteDetails) {
      state.selectedSite = props.selectedSiteDetails.Id;
    }
    this.state = state;
  }

  componentDidMount = () => {
    if (_.isEmpty(this.props.servingSites)) {
      this.props.setDateAndSetActions.getServingSites();
    }

    if (this.props.servingSites.length === 1) {
      this.setState({
        selectedSite: this.props.servingSites[0].value,
      });
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.servingSites.length === 0) {
      // User has access to only one serving site, use that site
      if (this.props.servingSites.length === 1) {
        this.setState({
          selectedSite: this.props.servingSites[0].value,
        });
      }
    }

    if (!prevProps.serverTime && this.props.serverTime) {
      this.setState({
        siteDate: moment(this.props.serverTime),
      });
    }

    /** Set default time if there was an error retrieving server time */
    if (!prevProps.serverTimeError && this.props.serverTimeError) {
      this.setState({
        siteDate: moment(),
      });
    }
  }

  saveSiteAndDate = async () => {
    const { siteDate } = this.state;
    const { actualDT, online } = this.props;
    let selectedSite = this.state.selectedSite;
    if (!selectedSite) {
      selectedSite = this.props.selectedSiteDetails.Id;
    }

    if (!siteDate) {
      return createToast(
        toastType.error,
        'Error',
        'Please select a date',
        true
      );
    }

    if (!selectedSite) {
      return createToast(
        toastType.error,
        'Error',
        'Please select a site',
        true
      );
    }

    if (online && siteDate.isBefore(moment(actualDT))) {
      return createToast(
        toastType.error,
        'Error',
        'Invalid Serving Date.  Serving is not allowed on a day in a closed school year.',
        true
      );
    }

    this.props.setDateAndSetActions.setSiteAndDate(
      {
        siteDate,
        selectedSite,
      },
      this.props.location.pathname,
      this.props.history
    );

    /**
     * Trigger retreiving POS data, store offline data
     * occurs when the user has clicked Done when selecting the date & site
     */
    this.props.getPosData(selectedSite, siteDate);

    this.closeModal(siteDate, selectedSite);
  };

  handleSiteNameChange = (e, item) => {
    this.setState({
      selectedSite: item.value,
    });
  };

  handleCalendarChange = date => {
    this.setState({
      siteDate: date,
    });
  };
  closeModal = (siteDate, selectedSite) => {
    this.props.setDateAndSetActions.setSiteDatePopupClose();

    if (!siteDate || !selectedSite) {
      if (_.isEmpty(this.props.selectedSiteDetails)) {
        this.props.history.replace('/home');
        this.props.toggleFullscreen(false);
      }
    }
  };
  render() {
    const { servingSites, isSetDateAndSitePopupOpen } = this.props;
    const { siteDate, selectedSite } = this.state;

    return (
      <SetDateAndSiteComponent
        siteDate={siteDate}
        open={isSetDateAndSitePopupOpen}
        saveSiteAndDate={this.saveSiteAndDate}
        handleSiteNameChange={this.handleSiteNameChange}
        handleCalendarChange={this.handleCalendarChange}
        closeModal={this.closeModal}
        selectedSite={selectedSite}
        servingSites={servingSites}
      />
    );
  }
}

const mapStateToProps = state => ({
  itemCategories: POSSelectors.getItemCategories(state),
  selectedSiteDetails: POSSelectors.getSelectedSiteDetails(state),
  siteDate: POSSelectors.getSelectedDate(state),
  isSetDateAndSitePopupOpen: POSSelectors.getIsSetDateAndSitePopupOpen(state),
  servingSites: POSSelectors.getServingSitesOptions(state),
  serverTime: CommonSelectors.getServerTime(state),
  serverTimeError: CommonSelectors.getServerTimeError(state),
  actualDT: CommonSelectors.actualDT(state),
  online: CommonSelectors.getOnline(state) && CommonSelectors.getServerUp(state),
});

const mapDispatchToProps = dispatch => ({
  getServerTime: () => dispatch(getServerTime()),
  getPosData: (siteId, date) => dispatch(getPosData(siteId, date)),
  setDateAndSetActions: bindActionCreators(setDateAndSetActions, dispatch),
  mealTypesActions: bindActionCreators(mealTypesActions, dispatch),
  toggleFullscreen: (fullscreen, element) =>
    dispatch(toggleFullscreen(fullscreen, element)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SetDateAndSite)
);



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/setDateAndSite/container/index.js